import logo from "./../../images/logo-white.png";

const navigation = [
  { name: "Terapias", href: "#terapias" },
  { name: "Enfoque", href: "#enfoque" },
  { name: "Precios", href: "#precios" },
  { name: "Preguntas Frecuentes", href: "#faq" },
];

export default function Navbar() {
  return (
    <header className="bg-indigo-500">
      <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" aria-label="Top">
        <div className="flex w-full items-center justify-between border-b border-indigo-500 py-6 lg:border-none">
          <div className="flex items-center">
            <a href="#">
              <span className="sr-only">Your Company</span>
              <img className="h-10 w-auto" src={logo} alt="" />
            </a>
            <div className="ml-10 hidden space-x-8 lg:block">
              {navigation.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-base font-medium text-white hover:text-indigo-50"
                >
                  {link.name}
                </a>
              ))}
            </div>
          </div>
          <div className="ml-10 space-x-4">
            <a
              href="#precios"
              className="inline-block rounded-md border border-transparent bg-indigo-400 py-2 px-4 text-base font-medium text-white hover:bg-opacity-75"
            >
              Agenda aquí
            </a>
          </div>
        </div>
        <div className="flex flex-wrap justify-center space-x-6 py-4 lg:hidden">
          {navigation.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className="text-base font-medium text-white hover:text-indigo-50"
            >
              {link.name}
            </a>
          ))}
        </div>
      </nav>
    </header>
  );
}
